<template>
  <div>
    <div align="left">
      <h5 class="h5 mb-3 text-primary font-weight-bold">Article</h5>
    </div>
    <br />
    <b-card class="text-left">
      <h5 class="font-weight-bold text-primary">Edit Article</h5>
      <br />
      <br />
      <b-row>
        <b-col>
          <div>
            <b-row>
              <b-col md="12">
                <b-row>
                  <b-col md="6">
                    <b-form-group
                      id="input-group-1"
                      class="required"
                      label-class="control-label"
                      label="Group Title"
                      label-for="input-1"
                    >
                      <input
                        id="input-1"
                        type="text"
                        class="form-control"
                        v-validate="'required|max:25'"
                        name="group_title"
                        data-vv-as="Group Title"
                        v-model="items.group_title"
                        placeholder="Group Title"
                      />
                      <b-form-invalid-feedback
                        id="input-group_title-feedback"
                      >{{ veeErrors.first('group_title') }}</b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                </b-row>
                <div class="form-group" v-for="(input , k) in items.reasons" :key="k">
                  <b-row>
                    <b-col md="3">
                      <b-form-group
                        id="fieldset-1"
                        label-class="mb-0"
                        label-for="input-1"
                      >Reason {{k+1}}</b-form-group>
                    </b-col>
                    <b-col md="3" class="text-right">
                      <b-link
                        style="text-decoration: none;"
                        class="text-danger"
                        @click="remove(k)"
                        v-show="k || ( !k && items.reasons.length > 1)"
                      >Remove</b-link>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="6">
                      <input
                        id="input-1"
                        type="text"
                        class="form-control"
                        v-validate="'required|max:25'"
                        name="title_id"
                        data-vv-as="Title Bahasa"
                        v-model="input.reason_id"
                        placeholder="Title Bahasa"
                      />
                      <b-form-invalid-feedback
                        id="input-title_id-feedback"
                      >{{ veeErrors.first('title_id') }}</b-form-invalid-feedback>
                    </b-col>
                    <b-col>
                      <input
                        id="input-1"
                        type="text"
                        class="form-control"
                        v-validate="'required|max:25'"
                        name="title_en"
                        data-vv-as="Title English"
                        v-model="input.reason_en"
                        placeholder="Title English"
                      />
                      <b-form-invalid-feedback
                        id="input-title_en-feedback"
                      >{{ veeErrors.first('title_en') }}</b-form-invalid-feedback>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="3" class="mt-4">
                      <b-button
                        block
                        variant="outline-primary"
                        @click="add(k)"
                        v-show="k == items.reasons.length-1"
                      >
                        <i class="fas fa-plus"></i> Add More
                      </b-button>
                    </b-col>
                  </b-row>
                </div>
                <br />
                <b-row class="text-right">
                  <b-col>
                    <b-button
                      variant="primary"
                      @click="post()"
                      :disabled="loading"
                      class="mr-5"
                    >Save</b-button>
                    <router-link :to="{name: 'Reason'}">
                      <b-button variant="outline-secondary">Cancel</b-button>
                    </router-link>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      group_title: '',
      items: [],
    };
  },
  beforeCreate() {
    // this.$store.dispatch("getDonatur");
    this.$store.dispatch('RatingModule/getReason', this.$route.params.id);
  },
  created() {
    this.$store.watch(
      state => state.RatingModule.reason_id,
      (newValue, oldValue) => {
        this.items = newValue;
        // Do whatever makes sense now
        if (this.items.length === 0) {
          this.loading = true;
        } else {
          this.loading = false;
        }
      },
    );
  },
  methods: {
    add(index) {
      this.items.reasons.push({
        id: '',
        reason_id: '',
        reason_en: '',
      });
    },
    remove(index) {
      this.items.reasons.splice(index, 1);
    },
    post() {
      this.$swal({
        title: 'Are you sure?',
        text: 'You will update this Reason!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, update it!',
      }).then((result) => {
        if (result.value) {
          this.$validator.validateAll().then((result) => {
            if (result) {
              const formData = new FormData();
              formData.append('group_title', this.items.group_title);
              $.each(this.items.reasons, (index, value) => {
                formData.append('sequence', index);
                formData.append(`id[${index}]`, value.id);
                formData.append(`reason_id[${index}]`, value.reason_id);
                formData.append(`reason_en[${index}]`, value.reason_en);
              });
              this.loading = true;
              this.$store
                .dispatch('RatingModule/putReason', {
                  id: this.$route.params.id,
                  formData,
                })
                .then((response) => {
                  this.loading = false;
                  this.$router.push({ name: 'Reason' });
                  this.$swal({
                    type: 'success',
                    title: 'Your work has been saved',
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  console.log(response);
                })
                .catch((error) => {
                  this.loading = false;
                  this.serverError = error.response.data;
                  this.$swal({
                    type: 'error',
                    title: 'Oops...',
                    text: error.response.data.message,
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  console.log(error);
                });
            } else {
              this.$swal('ERROR!', 'Your file cant be submit.', 'warning');
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped>
</style>
